import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Benefits } from './components/Benefits';
import { Curriculum } from './components/Curriculum';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="page-bg w-full font-sans text-tinta" data-id="element-0" data-mp="31agput0v2nlk">
      <Hero data-id="element-1" data-mp="31c1ksjr388jy" />
      <main data-id="element-2" data-mp="31cjo20c63n1d">
        <Problems data-id="element-3" data-mp="2wk06ksad07ra" />
        <Benefits data-id="element-4" data-mp="2wjgu3r3habkn" />
        <Curriculum data-id="element-5" data-mp="2wj8cxn0bok3n" />
        <Comparison data-id="element-6" data-mp="2wip54z4dzc3c" />
        <Testimonials data-id="element-7" data-mp="2wi5mfg6wwjo9" />
        <Bonuses data-id="element-8" data-mp="28tw62tsgwo4i" />
        <Offer data-id="element-9" data-mp="28te0v7ntuzkg" />
      </main>
      <Footer data-id="element-10" data-mp="28sl3gxardmez" />
    </div>;
}